import { template as template_218216a112ff4d8297fb49af8b8d2ec2 } from "@ember/template-compiler";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
export default template_218216a112ff4d8297fb49af8b8d2ec2(`
  <label class="w-full mb-2 block text-sm font-normal text-gray-dark" {{mergeClasses}} ...attributes>
    {{yield}}
  </label>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
